import _ from 'underscore';
import { productTypes } from '@fr/constants';
import { IBackboneProduct } from '@ve/types/backboneModels/Domain/ObjectValue';
import { BackboneSearchFormModel } from '@ve/types/backboneModels/BackboneSearchFormModel';
import Backbone from 'backbone';
import HotelTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/hotelTrackingService';
import HotelPagePriceJumpTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/HotelPagePriceJumpTrackingService';
import getTopBlocksPerDate from './getTopBlocksPerDate';
import trackingService from '../tracking';

type IParamsForTrackingHotelSearch = {
    tourCriteria: any,
    model: any;
    searchFormModel: BackboneSearchFormModel,
    startSearchTime: number,
    firstCacheTime: number,
    searchFinishedTime: number,
}

export default (previousTourProducts: Backbone.Collection<IBackboneProduct>, params: IParamsForTrackingHotelSearch): void => {
    const {
        tourCriteria,
        model,
        searchFormModel,
        startSearchTime,
        firstCacheTime,
        searchFinishedTime,
    } = params;

    let tourMinPrice: number | undefined;
    const currentDateTours: IBackboneProduct[] = model.get('filteredTourProducts');
    const checkInDateRange = searchFormModel.get('checkInDateRange').get('model');
    const flexibleDateSelected = checkInDateRange.get('from').getTime() !== checkInDateRange.get('to').getTime();
    const toursCountForSearchInterval = flexibleDateSelected
        ? previousTourProducts.length
        : (currentDateTours.length || 0);
    const filterCriteria = model.get('filterCriteria');
    const productTypeByFilterCriteria = filterCriteria.get('productType');
    const trackingOptions = {
        tourCriteria,
        toursCountForSearchInterval,
        foundTours: previousTourProducts,
        timestamp: startSearchTime,
        firstCacheTime,
        searchFinishedTime,
        productTypeByFilterCriteria,
        topBlocksPerDate: getTopBlocksPerDate(previousTourProducts),
    };

    console.log('TEST BLOCKS', trackingOptions.topBlocksPerDate);

    const selectedProductType = productTypeByFilterCriteria === productTypes.ALL
        ? productTypes.TOUR_OFFER
        : productTypeByFilterCriteria;

    const filteredProducts = model.filterTourProductsByProductTypeWithTourPriority(previousTourProducts.models, selectedProductType);

    const filteredTourProducts = flexibleDateSelected
        ? filteredProducts.models
        : model.filterTourProductsByDate(filteredProducts.models, filterCriteria.get('selectedTabDate'));

    const minPriceTourProduct = filteredTourProducts.length
        ? _.min(filteredTourProducts, (tourProduct) => tourProduct.get('product').get('priceWithOilTax') ?? tourProduct.get('product').get('price'))
        : null;
    if (minPriceTourProduct) {
        tourMinPrice = minPriceTourProduct.get('product').get('priceWithOilTax')
            || minPriceTourProduct.get('product').get('price') + (minPriceTourProduct.get('product').get('oilTax') || 0);
        Object.assign(trackingOptions, {
            tourMinPrice,
            tourMinPriceId: minPriceTourProduct.get('id'),
            tourMinPriceOilTax: minPriceTourProduct.get('product')?.get('oilTax'),
            tourMinPriceOperatorId: minPriceTourProduct.get('product').get('operator')?.id,
        });
    }

    const urlParams = model.get('urlParams');
    const hotelTrackingService = new HotelTrackingService();
    hotelTrackingService.setPriceJumpTrackingService(new HotelPagePriceJumpTrackingService());

    if (model.get('searchStartCounter') === 1 && !_.isEmpty(urlParams)) {
        Object.assign(trackingOptions, {
            originalSearchUuid: urlParams.suuid,
            serpCheapestPrice: urlParams.minPrice,
            serpCheapestPriceOilTax: urlParams.oilTaxPrice,
            serpCheapestPriceId: urlParams.identity,
            serpCheapestPriceOperatorId: urlParams.operatorId,
        });
        hotelTrackingService.trackHotelJumpPrice(tourMinPrice, +urlParams.minPrice);
    }
    trackingService.hotelSearchSessions(trackingOptions);
};